import { Stack, Typography } from '@mui/material';
import { FC, JSXElementConstructor, ReactElement, ReactFragment, ReactPortal } from 'react';

type LabelProps = {
  label:
    | string
    | number
    | boolean
    | ReactElement<any, string | JSXElementConstructor<any>>
    | ReactFragment
    | ReactPortal
    | null
    | undefined;
  required?: boolean;
  disabled?: boolean;
};

type OptionalLabelProps = {
  required?: boolean;
};

const OptionalLabel: React.FC<OptionalLabelProps> = ({ required }) => {
  return (
    <Typography
      variant="label12Medium"
      lineHeight="16px"
      fontStyle="italic"
      color="grey.400"
      sx={{ display: 'block', height: '16px' }}
    >
      {required ? ' ' : '(optional)'}
    </Typography>
  );
};

export const Label: FC<LabelProps> = ({ label, required, disabled }) => {
  return label ? (
    <Stack gap={required ? '0px' : '6px'} flexDirection="row" paddingBottom="2px" alignItems="center">
      <Typography variant="label14Bold" lineHeight="18px" color={disabled ? 'grey.300' : 'grey.700'}>
        {label}
      </Typography>
      <OptionalLabel required={required} />
    </Stack>
  ) : (
    <></>
  );
};
